let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4CXvt")).then(() => parcelRequire('kpsfH'));